export default "__VITE_ASSET__DQUNXsrX__"